import axios from "axios";
import { stakingApiConfig } from "@/constant/config";
import { EXECUTE_RESULT } from "@/constant/config";
const queryString = require('query-string');
const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
};

export default {
    getActiveCampaign() { 
        return axios({
            method: "GET",
            url: `${stakingApiConfig.getActiveCampaign}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    getActivePolicy(request) { 
        return axios({
            method: "POST",
            url: `${stakingApiConfig.getActivePolicy}`,
            headers: headers,
            timeout: 15000,
            data: request,
            withCredentials: true
        });
    },
    getActiveTime(request){
        return axios({
            method: "POST",
            url: `${stakingApiConfig.getActiveTime}`,
            headers: headers,
            timeout: 15000,
            data: request,
            withCredentials: true
        });
    },
    getTransactionOfCampaign(campaignId, pagination) { 
        let queryParams = queryString.stringify({ campaignId, ...pagination});
        return axios({
            method: "GET",
            url: `${stakingApiConfig.getTransactionOfCampaign}?${queryParams}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    getTransactionOfUser(pagination) { 
        let queryParams = queryString.stringify(pagination);
        return axios({
            method: "GET",
            url: `${stakingApiConfig.getTransactionOfUser}?${queryParams}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    getDetailTransaction() { 
        return axios({
            method: "GET",
            url: `${stakingApiConfig.getDetailTransaction}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    stakeTransaction(data) { 
        return axios({
            method: "POST",
            url: `${stakingApiConfig.stakeTransaction}`,
            headers: headers,
            timeout: 15000,
            data,
            withCredentials: true
        });
    },
    unstakeTransaction(transId) { 
        return axios({
            method: "POST",
            url: `${stakingApiConfig.unstakeTransaction}/${transId}`,
            headers: headers,
            timeout: 15000,
            data: {},
            withCredentials: true
        });
    },
    getBalance(){ 
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: `${stakingApiConfig.getBalance}`,
                headers: headers,
                timeout: 15000,
                withCredentials: true
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
}